import { ServerCard } from '../../types';

export const checkArraysEquality = (initialArray: ServerCard[], comparingArray: ServerCard[]) => {
  return (
    initialArray.length === comparingArray.length &&
    comparingArray.every((card, index) => card.cardId === initialArray[index].cardId)
  );
};
